import Vue from 'vue'
import TreeTable from 'vue-table-with-tree-grid'
import less from 'less'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './style/global.css'
import * as echarts from 'echarts';
//过滤器方法的引入
import * as filters from './filters/index'
Vue.use(ElementUI)
Vue.component('tree-table', TreeTable)
Vue.use(less)
Vue.prototype.$echarts = echarts //引入组件
Vue.config.productionTip = false

//全局注册过滤器
Object.keys(filters).forEach((item) =>{
  Vue.filter(item,filters[item])
})

Vue.prototype.$hasPermission = function (permission) {
  let permissions = store.state.user.permissions;
  return permissions && permissions.indexOf(permission) > -1;
};

Vue.prototype.$hasRole = function (permission) {
  let permissions = store.state.user.roles;
  return permissions && permissions.indexOf(permission) > -1;
};

router.beforeEach((to, from, next) => {
  if(to.meta.requireAuth){
    if(store.state.user.account){
      next()
    }else{
      next({
        path: 'login',
        query: {redirect: to.fullPath}
      })
    }
  }else{
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
